// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uBDOmINYW9oEX16qvxRX{margin-bottom:-8px}.uBDOmINYW9oEX16qvxRX .mPoOwisystALQzYS_Rbk{color:var(--content-primary-primary);box-sizing:content-box;text-align:center;height:24px;padding:12px 8px 24px;font-size:24px;font-weight:500}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `uBDOmINYW9oEX16qvxRX`,
	"label": `mPoOwisystALQzYS_Rbk`
};
export default ___CSS_LOADER_EXPORT___;
